import * as Yup from 'yup';

export const FAQ_VALIDATION_SCHEMA = Yup.object().shape({
  question: Yup.string().required('Обязательное поле').max(200, 'Превышено максимальное число символов'),
  answer: Yup.string().required('Обязательное поле').max(500, 'Превышено максимальное число символов'),
});
